export default __webpack_public_path__ + "static/6-b62d7e06b469e1227e760639b5b6d7bf.png";